import React, { useEffect, useState, useRef, useLayoutEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
// import { useQuill } from "react-quilljs";
// import "quill/dist/quill.snow.css";

import PageHeader from "../components/PageHeader";
import infoCircle from "../assets/info-circle.svg";
import TagInput from "../components/TagInput";
import { requestWithToken } from "../utils/apis"
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import moment from "moment";
import MediaPickerModal from "../components/MediaPickerModal";
import OGFields from "../components/pages/OGTagsFields";

const AddCaseStudy = () => {
  const navigate = useNavigate();
  const { blogId } = useParams();
  const [showMediaPicker, setShowMediaPicker] = useState(false);
  const [banner, setBanner] = useState(null); // for selected banner
  const rightSectionRef = useRef(null);
  const [mediaPicker, setMediaPicker] = useState({
    open: false,
    targetField: null
  });
  const [showOGMediaPicker, setShowOGMediaPicker] = useState(false);

  // const modules = {
  //   toolbar: [
  //     [{ header: [1, 2, 3, false] }],
  //     ["bold", "italic", "underline", "strike"],
  //     [{ list: "ordered" }, { list: "bullet" }],
  //     ["blockquote", "code-block"],
  //     ["link", "image"],
  //     [{ align: [] }],
  //   ],
  // };

  // const formats = [
  //   "header",
  //   "bold",
  //   "italic",
  //   "underline",
  //   "strike",
  //   "list",
  //   "bullet",
  //   "blockquote",
  //   "code-block",
  //   "link",
  //   "image",
  //   "align",
  // ];

  // const { quill, quillRef } = useQuill({
  //   theme: "snow",
  //   modules,
  //   formats,
  //   placeholder: "Write your blog content...",
  // });

  const formik = useFormik({
    initialValues: {
      title: "",
      slug: "",
      author: "",
      focus_keywords: [],
      metaTitle: "",
      metaDesc: "",
      is_published: true,
      banner: "",
      desc: "",
      extras: {
        url: "",
        author_designation: "",
        author_desc: ""
      },
      publish_date:moment().format("YYYY-MM-DD"),
    },
    validationSchema: Yup.object({
      title: Yup.string().required("Case Study Title is required"),
      // pdf: Yup.mixed()
      //   .required("PDF file is required")
      //   .test(
      //     "fileType",
      //     "Only PDF files are allowed",
      //     value => value && value.type === "application/pdf"
      //   ),
      slug: Yup.string()
        .matches(
          /^[a-z0-9-_]+$/,
          "Slug can only contain lowercase letters, numbers, hyphens, and underscores"
        ),
      // content: Yup.string().required("Case Study Content is required"),
      // focus_keywords: Yup.array().min(1, "At least one keyword is required"),
      metaTitle: Yup.string(),
      metaDesc: Yup.string(),
      banner: Yup.string().required("Banner image is required"),
    }),
    onSubmit: async (values, { setSubmitting, resetForm }) => {
      try {
        const bannerpath = banner
          ? banner.replace(process.env.REACT_APP_BUCKET_URL, "")
          : null;

        const payload = {
          title: values.title,
          slug: values.slug,
          content: values.content,
          author_name: values.author,
          seo: {
            focus_keywords: values.focus_keywords.join(","),
            metaTitle: values.metaTitle,
            metaDesc: values.metaDesc,
          },
          assets: {
            type: 1,
            url: values.banner,
            w: "0",
            h: "0",
          },
          is_published: values.is_published,
          publish_date:moment(values.publish_date).toISOString(),
          desc: values.desc,
          type: 2,
          extras: {
            url: values.extras.url,
            author_designation: values.extras.author_designation,
            author_desc: values.extras.author_desc
          }
        };

        // if (!values.is_published) {
        //   delete payload.publish_date
        // }
        let response = null;
        if (blogId) {
          response = await requestWithToken(
            "PUT",
            `/api/blogs/${blogId}`,
            payload
          );
        } else {
          response = await requestWithToken("POST", "/api/blogs", payload);
        }

        if (response?.status === 200) {
          toast.success(blogId ? "Case Study Updated Successfully!" : "Case Study Created Successfully!");
          navigate("/case-studies");
          resetForm();
          // if (quill) quill.root.innerHTML = ""; // reset editor
        }
      } catch (error) {
        console.error("Error submitting blog:", error);
        toast.error(
          error?.response?.data?.message ||
          "Something went wrong. Please try again."
        );
        if (loadingButton === "toggle") {
          // revert the toggle change if error occurs during publish toggle
          formik.setFieldValue("is_published", !formik?.values?.is_published);
        }
      } finally {
        setSubmitting(false);
        setLoadingButton(null)
      }
    },
  });

  useLayoutEffect(() => {
    if (!rightSectionRef.current) return;

    const element = rightSectionRef.current;

    const updateHeight = () => {
      const height = element.offsetHeight;
      document.documentElement.style.setProperty(
        "--right-section-height",
        `${height}px`
      );
    };

    updateHeight();

    const ro = new ResizeObserver(updateHeight);
    ro.observe(element);

    return () => ro.disconnect();
  }, [formik.values.content]);



  // useEffect(() => {
  //   if (quill) {
  //     quill.on("text-change", () => {
  //       formik.setFieldValue("content", quill.root.innerHTML);
  //     });
  //   }
  // }, [quill]);

  // Fetch blog details in edit mode
  const fetchDetails = async (id) => {
    try {
      const response = await requestWithToken("GET", `/api/blogs/${id}`);
      if (response?.status === 200) {
        const blog = response.data.data;

        formik.setValues({
          title: blog.title || "",
          slug: blog.slug || "",
          content: blog.content || "",
          author: blog.author_name || "",
          focus_keywords: blog.seo?.focus_keywords
            ? blog.seo.focus_keywords.split(",")
            : [],
          metaTitle: blog.seo?.metaTitle || "",
          metaDesc: blog.seo?.metaDesc || "",
          is_published: blog.is_published || false,
          banner: blog.assets?.url || "",
          desc: blog?.desc || "",
          extras: blog?.extras || {},
          publish_date: moment(blog?.publish_date).format("YYYY-MM-DD") || ""
        });

        formik.setFieldValue("desc", blog.desc || "");
        setBanner(blog.assets?.url ? process.env.REACT_APP_BUCKET_URL + blog.assets.url : null);
      }
    } catch (error) {
      console.error("Error fetching blog details:", error);
      toast.error("Failed to fetch blog details");
    }
  };

  useEffect(() => {
    if (blogId) {
      fetchDetails(blogId);
    }
  }, [blogId]);

  const [loadingButton, setLoadingButton] = useState(null);

  const handlePublishToggle = async () => {
    setLoadingButton("toggle");
    const errors = await formik.validateForm();

    if (Object.keys(errors).length === 0) {
      // No validation errors → safe to toggle publish
      formik.setFieldValue("is_published", !formik?.values?.is_published);
      await formik.submitForm(); // same as handleSubmit but returns a Promise
    } else {
      formik.setTouched(
        Object.keys(errors).reduce((acc, key) => {
          acc[key] = true;
          return acc;
        }, {})
      );
      setLoadingButton(null); // stop loader if invalid
    }
  };

  const handleSaveOrUpdate = async () => {
    setLoadingButton("save");
    const errors = await formik.validateForm();

    if (Object.keys(errors).length === 0) {
      await formik.submitForm();
    } else {
      formik.setTouched(
        Object.keys(errors).reduce((acc, key) => {
          acc[key] = true;
          return acc;
        }, {})
      );
      setLoadingButton(null); // stop loader if invalid
    }
  };

  return (
    <>
      <PageHeader pageTitle={blogId ? "Case Study" : "Add Case Study"}>

        <button
          className="btn-white"
          onClick={handlePublishToggle}
          disabled={loadingButton === "toggle" && formik.isSubmitting}
        >
          {loadingButton === "toggle" && formik.isSubmitting ? (
            <Spinner size="sm" />
          ) : formik?.values?.is_published ? (
            blogId ? "Unpublish" : "Save Draft"
          ) : (
            "Publish"
          )}
        </button>

        <button
          className="btn-black"
          onClick={handleSaveOrUpdate}
          disabled={loadingButton === "save" && formik.isSubmitting}
        >
          {loadingButton === "save" && formik.isSubmitting ? (
            <Spinner size="sm" />
          ) : blogId ? (
            "Update"
          ) : (
            "Publish"
          )}
        </button>

      </PageHeader>

      <div className="page-container">
        <div className="add-blog-form">
          <div className="row">
            {/* Left Section */}
            <div className="col-md-8 d-flex flex-column">
              <div className="theme-card text-card p-3 mb-3 h-100 ">
                {/* Case Study Content (Quill) */}
                <div className="frm-group" style={{ height: "100%" }}>
                  <div className="d-flex align-items-center mb-2">
                    <label className="frm-label d-flex align-items-center">
                      Case Study PDF
                      <img
                        className="ms-2"
                        src={infoCircle}
                        alt="Info"
                        title="Upload Case Study PDF"
                      />
                    </label>
                    <button
                      className="btn-black ms-auto"
                      onClick={() =>
                        setMediaPicker({
                          open: true,
                          targetField: "extras.url", // ← store exact field path
                        })
                      }
                    >
                      Upload PDF
                    </button>
                  </div>
                  <div className="pointer" style={{ height: "100%" }}>
                    {formik.values.extras.url ? (
                      <iframe
                        src={`${process.env.REACT_APP_BUCKET_URL}${formik.values.extras?.url}#page=1`}
                        title="PDF Preview"
                        style={{
                          width: "100%",
                          height: "100%",
                          borderRadius: "12px",
                          border: "2px solid #ddd",
                          overflow: "hidden",
                        }}
                      />
                    ) : (
                      <div
                        style={{
                          width: "130px",
                          height: "130px",
                          borderRadius: "12px",
                          background: "#f5f5f5",
                          color: "#777",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        No Media
                      </div>
                    )}
                  </div>

                  {/* {formik.touched.pdf && formik.errors.pdf && (
                    <div className="input-error">{formik.errors.pdf}</div>
                  )} */}
                </div>
              </div>
            </div>

            {/* Right Section */}
            <div className="col-md-4 position-relative">
              <div className="right-sec" ref={rightSectionRef}>
                {/* General Details */}
                <div className="theme-card p-4 mb-3">
                  <div className="card-title pb-3">General Details</div>

                  {/* Case Study Title */}
                  <div className="frm-group">
                    <label className="frm-label d-flex align-items-center">
                      Case Study Title
                      <img
                        className="ms-2"
                        src={infoCircle}
                        alt="Info"
                        title="Add Case Study Title"
                      />
                    </label>
                    <input
                      type="text"
                      name="title"
                      className="frm-input"
                      placeholder="Enter Case Study Title"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.title}
                    />
                    {formik.touched.title && formik.errors.title && (
                      <div className="input-error">{formik.errors.title}</div>
                    )}
                  </div>

                  {/* Slug */}
                  <div className="frm-group">
                    <label className="frm-label d-flex align-items-center">
                      Slug
                      <img
                        className="ms-2"
                        src={infoCircle}
                        alt="Info"
                        title="Add Slug name of Case Study"
                      />
                    </label>
                    <input
                      type="text"
                      name="slug"
                      className="frm-input"
                      placeholder="Slug name eg. my-first-blog"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.slug}
                    />
                    {formik.touched.slug && formik.errors.slug && (
                      <div className="input-error">{formik.errors.slug}</div>
                    )}
                  </div>
                  <div className="frm-group">
                    <label className="frm-label d-flex align-items-center">
                      Publish Date
                      <img
                        className="ms-2"
                        src={infoCircle}
                        alt="Info"
                        title="Select publish date"
                      />
                    </label>
                    <input
                      type="date"
                      name="publish_date"
                      className="frm-input"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.publish_date}
                    />
                  </div>
                  <div className="frm-group">
                    <label className="frm-label d-flex align-items-center">
                      Author Name
                      <img
                        className="ms-2"
                        src={infoCircle}
                        alt="Info"
                        title="Add Author name of Case Study"
                      />
                    </label>
                    <input
                      type="text"
                      name="author"
                      className="frm-input"
                      placeholder="Author Name eg. John Doe"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.author}
                    />
                    {formik.touched.author && formik.errors.author && (
                      <div className="input-error">{formik.errors.author}</div>
                    )}
                  </div>
                  <div className="frm-group">
                    <label className="frm-label d-flex align-items-center">
                      Author Designation
                      <img
                        className="ms-2"
                        src={infoCircle}
                        alt="Info"
                        title="Add Author Designation"
                      />
                    </label>
                    <input
                      type="text"
                      name="extras.author_designation"
                      className="frm-input"
                      placeholder="Eg. Senior Analyst"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.extras.author_designation}
                    />
                  </div>
                  <div className="frm-group">
                    <label className="frm-label d-flex align-items-center">
                      About Author
                      <img
                        className="ms-2"
                        src={infoCircle}
                        alt="Info"
                        title="Add Author Description"
                      />
                    </label>
                    <textarea
                      name="extras.author_desc"
                      className="frm-input"
                      rows={3}
                      placeholder="Short bio about the author"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.extras.author_desc}
                    />
                  </div>

                  <div className="frm-group">
                    <label className="frm-label">Case Study Banner</label>

                    <div
                      className="pointer"
                      style={{
                        width: "100%",
                        height: "200px",
                        borderRadius: "12px",
                        overflow: "hidden",
                        cursor: "pointer",
                      }}
                      onClick={() =>
                        setMediaPicker({
                          open: true,
                          targetField: "banner", // ← store exact field path
                        })
                      }
                    >
                      {formik.values.banner ? (
                        <img
                          src={`${process.env.REACT_APP_BUCKET_URL}${formik.values.banner}`}
                          alt="banner preview"
                          style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        />
                      ) : (
                        <div
                          style={{
                            width: "100%",
                            height: "100%",
                            borderRadius: "12px",
                            background: "#f5f5f5",
                            color: "#777",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "14px",
                          }}
                        >
                          Upload Banner
                        </div>
                      )}
                    </div>
                    {formik.touched.banner && formik.errors.banner && (
                      <div className="input-error">{formik.errors.banner}</div>
                    )}

                  </div>
                  <div className="frm-group">
                    <label className="frm-label d-flex align-items-center">
                      Description
                      <img
                        className="ms-2"
                        src={infoCircle}
                        alt="Info"
                        title="Add description of Case Study"
                      />
                    </label>
                    <input
                      type="text"
                      name="desc"
                      className="frm-input"
                      placeholder="Enter Description"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.desc}
                    />
                  </div>
                </div>

                {/* SEO Section */}
                <div className="theme-card p-4 mb-3">
                  <div className="card-title pb-3">SEO</div>

                  {/* Focus Keywords */}
                  <div className="frm-group">
                    <label className="frm-label d-flex align-items-center">
                      Focus Keywords
                      <img
                        className="ms-2"
                        src={infoCircle}
                        alt="Info"
                        title="Add Keywords"
                      />
                    </label>
                    <div className="tag-card">
                      <TagInput
                        value={formik.values.focus_keywords}
                        onChange={(tags) =>
                          formik.setFieldValue("focus_keywords", tags)
                        }
                      />
                      {formik.touched.focus_keywords &&
                        formik.errors.focus_keywords && (
                          <div className="input-error">
                            {formik.errors.focus_keywords}
                          </div>
                        )}
                    </div>
                  </div>

                  {/* SEO Title */}
                  <div className="frm-group">
                    <label className="frm-label d-flex align-items-center">
                      SEO Title
                      <img
                        className="ms-2"
                        src={infoCircle}
                        alt="Info"
                        title="Add SEO Title"
                      />
                    </label>
                    <input
                      type="text"
                      name="metaTitle"
                      className="frm-input"
                      placeholder="Enter SEO Title"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.metaTitle}
                    />
                    {formik.touched.metaTitle && formik.errors.metaTitle && (
                      <div className="input-error">
                        {formik.errors.metaTitle}
                      </div>
                    )}
                  </div>

                  {/* Meta Description */}
                  <div className="frm-group">
                    <label className="frm-label d-flex align-items-center">
                      Meta Description
                      <img
                        className="ms-2"
                        src={infoCircle}
                        alt="Info"
                        title="Add Meta Description"
                      />
                    </label>
                    <textarea
                      name="metaDesc"
                      className="frm-input"
                      rows={3}
                      placeholder="Enter Meta Description"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.metaDesc}
                    />
                    {formik.touched.metaDesc && formik.errors.metaDesc && (
                      <div className="input-error">
                        {formik.errors.metaDesc}
                      </div>
                    )}
                  </div>
                </div>

                <OGFields
                  values={formik.values}
                  errors={formik.errors}
                  touched={formik.touched}
                  handleChange={formik.handleChange}
                  handleBlur={formik.handleBlur}
                  setFieldValue={formik.setFieldValue}
                  showMediaPicker={showOGMediaPicker}
                  setShowMediaPicker={setShowOGMediaPicker}
                />
              </div>
            </div>
            {/* End Right Section */}
          </div>
        </div>
      </div >
      {/* {showMediaPicker && (
        <MediaPickerModal
          show={showMediaPicker}
          onClose={() => setShowMediaPicker(false)}
          onSelect={(mediaUrl) => {
            setBanner(mediaUrl);
            formik.setFieldValue("banner", mediaUrl);
            setShowMediaPicker(false);
          }}
        />
      )} */}
      < MediaPickerModal
        show={mediaPicker.open}
        onClose={() => setMediaPicker({ open: false, targetField: null })}
        onSelect={(url) => {
          if (mediaPicker.targetField) {
            // only save the relative URL (after bucket)
            const cleanUrl = url.replace(process.env.REACT_APP_BUCKET_URL, "");

            formik.setFieldValue(mediaPicker.targetField, cleanUrl);
          }
          setMediaPicker({ open: false, targetField: null });
        }}
      />
    </>
  );
};

export default AddCaseStudy;
